/* eslint-disable */

import * as THREE from 'three'

export default {

    uniforms:
    {
        'tDiffuse': { type: 't', value: null },
        'powRGB':   { type: 'v3', value: new THREE.Vector3( 2, 2, 2 ) },
        'mulRGB':   { type: 'v3', value: new THREE.Vector3( 1, 1, 1 ) }
    },

    vertexShader: `
        varying vec2 vUv;

        void main()
        {
            vUv = uv;

            gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
        }
    `,

    fragmentShader: `
        uniform sampler2D tDiffuse;
        uniform vec3 powRGB;
        uniform vec3 mulRGB;

        varying vec2 vUv;

        void main()
        {
            gl_FragColor = texture2D( tDiffuse, vUv );
            gl_FragColor.rgb = mulRGB * pow( gl_FragColor.rgb, powRGB );
        }

    `
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Shaders/ColorCorrection.js